import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const CloseCircle = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.66667C5.40833 1.66667 1.66666 5.40834 1.66666 10C1.66666 14.5917 5.40833 18.3333 10 18.3333C14.5917 18.3333 18.3333 14.5917 18.3333 10C18.3333 5.40834 14.5917 1.66667 10 1.66667ZM12.8 11.9167C13.0417 12.1583 13.0417 12.5583 12.8 12.8C12.675 12.925 12.5167 12.9833 12.3583 12.9833C12.2 12.9833 12.0417 12.925 11.9167 12.8L10 10.8833L8.08333 12.8C7.95833 12.925 7.8 12.9833 7.64166 12.9833C7.48333 12.9833 7.325 12.925 7.2 12.8C6.95833 12.5583 6.95833 12.1583 7.2 11.9167L9.11666 10L7.2 8.08334C6.95833 7.84167 6.95833 7.44167 7.2 7.20001C7.44166 6.95834 7.84166 6.95834 8.08333 7.20001L10 9.11667L11.9167 7.20001C12.1583 6.95834 12.5583 6.95834 12.8 7.20001C13.0417 7.44167 13.0417 7.84167 12.8 8.08334L10.8833 10L12.8 11.9167Z"
          fill={color}
        />
      </svg>
    );
  },
);
export default CloseCircle;
